(() => {
  const initReturnRequestForms = (root = document) => {
    root.querySelectorAll('.return-request').forEach((section) => {
      if (section.dataset.returnRequestReady === 'true') return;
      section.dataset.returnRequestReady = 'true';

      const input = section.querySelector('[data-return-file-input]');
      const label = section.querySelector('[data-return-file-label]');
      const summary = section.querySelector('[data-return-attachment-summary]');
      const fallbackText = label ? label.textContent : '';

      if (!input || !label || !summary) return;

      input.addEventListener('change', () => {
        const names = Array.from(input.files || []).map((file) => file.name);
        label.textContent = names.length ? names.join(', ') : fallbackText;
        summary.value = names.length
          ? `Customer selected these files locally: ${names.join(', ')}. Native Shopify contact forms do not attach uploaded files.`
          : '';
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initReturnRequestForms());
  document.addEventListener('shopify:section:load', (event) => initReturnRequestForms(event.target));
})();
